import { useContext } from 'react';
import CategoryContext from 'contexts/ListingType/components/CategoryPage/components/CategoryContext';

export default () => {
    const categoryConsumer = useContext(CategoryContext);
    return categoryConsumer?.state?.category;
};
